<script setup>
// import { ref } from 'vue';
import BlockTable from "./Tables/BlockTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Block Info</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Block Id</label>
                            <input class="form-control" v-model="model.block.blockid" id="input_block_id" type="text" placeholder="A01" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Block Nama</label>
                            <input class="form-control" v-model="model.block.blockname" id="input_block_name" type="text" placeholder="ACJ PL" />
                        </div>
                        <!-- <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Relong</label>
                            <input class="form-control" v-model="model.block.relong" id="input_relong" type="number" placeholder="1.9999" />
                        </div> -->
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Quantity (PK)</label>
                            <input class="form-control" v-model="model.block.quantity" id="input_quantity" type="number" placeholder="100" />
                        </div>
                        <!-- <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Estimate (Tonne)</label>
                            <input class="form-control" v-model="model.block.est_kg" id="input_est_kg" type="number" placeholder="1.0" />
                        </div> -->
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Lokasi</label>
                            <argon-input type="text" v-model="model.block.address" id="input_address" placeholder="213 Padng Lembu, 08330 Gurun Kedah" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Agreement</label>
                            <argon-input type="text" v-model="model.block.agreement" id="agreement" placeholder="agreement" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Umur</label>
                            <argon-input type="number" v-model="model.block.age" id="age" placeholder="age of tree" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Next Potong Date</label>
                            <input type="date" id="input_date" v-model="model.block.nextdate" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.block.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <h6>Payment Info</h6>
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Term</label>
                            <select class="form-control" v-model="model.block.term">
                                <option value="0">Free of Charge (FOC)</option>
                                <option value="1">Monthly</option>
                                <option value="2">Market Prices</option>
                                <option value="3">Share Profit (%)</option>
                                <option value="4">Share Net Profit (%)</option>
                            </select>
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Month <i class="fas fa-info-circle" title="bayar berapa bulan"></i></label>
                            <input class="form-control" v-model="model.block.month" id="input_month" type="number" placeholder="Number of Month (1year = 12)" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Total Amount</label>
                            <input class="form-control" v-model="model.block.amount" id="input_amount" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 4 || model.block.term == 3">
                            <label for="example-text-input" class="form-control-label text-danger " >Percent (Owner) <i class="fas fa-info-circle" title="Kalau owner 30%, record 0.3"></i></label>
                            <input class="form-control" v-model="model.block.percentowner" id="input_percent_owner" type="number" placeholder="0.3" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term == 2" >
                            <label for="example-text-input" class="form-control-label text-danger " >Market Price (RM) <i class="fas fa-info-circle" title="E.g (700-800 RM 4500),(800-900 RM 5000)"></i></label>
                            <input class="form-control" v-model="model.block.marketprice" id="input_marketprice" type="number" placeholder="E.g (700-800 RM 4500),(800-900 RM 5000)" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term != 0">
                            <label for="example-text-input" class="form-control-label">Bank</label>
                            <input class="form-control" v-model="model.block.bank" id="input_bank" type="text" placeholder="Publick Bank" />
                        </div>
                        <div class="col-md-2" v-show="model.block.term != 0">
                            <label for="example-text-input" class="form-control-label">Bank Acc</label>
                            <input class="form-control" v-model="model.block.bankacc" id="input_bankacc" type="number" placeholder="99999999999" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Name</label>
                            <input class="form-control" v-model="model.block.name" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Start Date</label>
                            <input class="form-control" v-model="model.block.startdate" id="input_startdate" type="date" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">End Date</label>
                            <input class="form-control" v-model="model.block.enddate" id="input_enddate" type="date" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Payment Info Remark</label>
                            <input class="form-control" v-model="model.block.paymentremark" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addBlock" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <BlockTable :key="componentKey" />
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'blockCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
      model:{
        block:{
            blockid:'',
            blockname:'',
            address:'',
            remark:'',
            relong:'',
            quantity:'',
            nextdate:'',
            age:'',
            term:0,
            amount:'0',
            bank:'',
            bankacc:'',
            name:'',
            agreement:'',
            marketprice:null,
            percentowner:null,
            month:null,
            paymentremark:null,
            startdate: null,
            enddate:null
        },
        

      }
    }
  },
  methods: {
    addBlock(){
        if(this.model.block.term == 1 && (this.model.block.month == null || this.model.block.amount <0)){
            alert("Month or amount can't be null or 0.");
            return null;
        }else if((this.model.block.term == 3 || this.model.block.term == 4 )&& this.model.block.percentowner <0){
            alert("Percent (Owner) can't be less than 0.");
            return null;
        }else if(this.model.block.term == 2 && this.model.block.marketprice == null){
            alert("Market Price can't be null.");
            return null;
        }
        // var mythis = this;
        axios.post('block/add',this.model.block)
            .then(res => {
                alert(res.data.message);
                this.model.block = {
                    blockname:'',
                    address:'',
                    remark:'',
                    relong:'',
                    quantity:'',
                    est_kg:'',
                    age:'',
                    blockid: '',
                    term:0,
                    amount:'',
                    bank:'',
                    bankacc:'',
                    name:'',
                    agreement:'',
                    marketprice:null,
                    percentowner:null,
                    month:null,
                    paymentremark:null,
                    startdate:null,
                    enddate:null,
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Block Name, ID, Payment Term and Amount is required! ');
                    }else if(error.response.status == 501){
                        alert('Error: Block ID duplicate! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>